import { Component, OnInit } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { Router } from '@angular/router';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';
import { InvoiceService } from '../../services/invoice.service';
import { RequestParams } from '../../../../common/rest-api/models/request-params';
import { ToasterService } from '../../../../../app/common/services/toaster.service';

@Component({
  selector: 'app-invoice-page',
  templateUrl: 'invoice.page.html',
  styleUrls: [
    './invoice.page.scss'

  ]
})
export class InvoicePage implements OnInit, ViewWillEnter {

  customerCode: string;
  startDate: Date;
  endDate: Date;
  public overdueInvoices: any;
  public invoices: any;
  currentRoute: string;
  overdueParams: any;
  invoiceParams: any;
  overdueTotalPages: number = 0;
  overdueTotalElements: number = 0;
  invoiceTotalPages: number = 0;
  invoiceTotalElements: number = 0;
  overdueCurrPage: number;
  invoiceCurrPage: number;
  overduePageSize: number;
  invoicePageSize: number;
  loaded:boolean=false;
  isCustomerCodeExist:boolean=false;
  submitted = false;

  constructor(
    private router: Router,
    private authService: GtrakAuthService,
    private invoiceService: InvoiceService,
    private toasterService: ToasterService,
    
  ) { 
    this.currentRoute = null;
  }

 async ngOnInit():Promise< void> {
    this.loaded=false;
    this.overdueCurrPage = 1;
    this.invoiceCurrPage = 1;
      if( localStorage.getItem("pageSize")!=null){
        this.invoicePageSize=Number(localStorage.getItem("pageSize"));
   }
   else{
    this.invoicePageSize = 500;
   }
     if( localStorage.getItem("pageSize")!=null){
        this.overduePageSize=Number(localStorage.getItem("pageSize"));
   }
   else{
    this.overduePageSize = 500;
   }
    this.overdueParams = new RequestParams();
    this.invoiceParams = new RequestParams();

    this.overdueParams.setPaging(this.overdueCurrPage, this.overduePageSize);
    this.invoiceParams.setPaging(this.invoiceCurrPage, this.invoicePageSize);

    if(!this.authService.user.canViewInvoice) {
      this.router.navigate([this.authService.user.homeLocation]);
    }
    this.customerCode = this.authService.user.customerCode;
    if( this.customerCode==null|| this.customerCode==undefined || this.customerCode==""){
        this.isCustomerCodeExist=false;
    }
    else{
      this.isCustomerCodeExist=true;
    }

    this.setDefaults();
    this.invoices = [];
    this.overdueInvoices = [];
    this.currentRoute = this.router.url;
    this.loaded=true;
  }

 async ionViewWillEnter(){
    this.setDefaults();
          if( localStorage.getItem("pageSize")!=null){
        this.overduePageSize=Number(localStorage.getItem("pageSize"));
   }
   else{
    this.overduePageSize = 500;
   }
         if( localStorage.getItem("pageSize")!=null){
        this.invoicePageSize=Number(localStorage.getItem("pageSize"));
   }
   else{
    this.invoicePageSize = 500;
   }
    this.submitted = false;
    await this.loadInvoice();
  }

  setDefaults(): void {
    const today = new Date(); 
    const start = new Date();
    start.setDate(today.getDate() - 30); 
    this.startDate = start.toISOString().substring(0, 10) as any;
    this.endDate = today.toISOString().substring(0, 10) as any;
  }
 async loadInvoice(){
   this.loaded=false;
    if(this.endDate && this.startDate && this.customerCode && this.customerCode != '') {
      this.submitted = true;
      this.overdueCurrPage = 1;
      this.invoiceCurrPage = 1;
      await this.getOverdueInvoices();
      await this.getInvoicesInRange(); 
    }
    this.loaded=true;
 }
  async getInvoices(): Promise<void> {
    this.loaded=false;
    if (this.authService.user.customerCode?.length > 0 && this.customerCode !== this.authService.user.customerCode) {
      this.toasterService.presentToast('danger', '', 'Invalid Customer Code', 1600);
      this.customerCode = this.authService.user.customerCode;
       this.loaded=true;
      return;
    }
    if(this.endDate && this.startDate && this.customerCode && this.customerCode != '') {
      this.submitted = true;
      this.overdueCurrPage = 1;
      this.invoiceCurrPage = 1;
      await this.getOverdueInvoices();
      await this.getInvoicesInRange();
    } else {
      this.toasterService.presentToast('danger', '', 'Please fill out all fields', 1600);
    }

    this.loaded=true;
  }

  async getOverdueInvoices(): Promise<any> {
    this.overdueParams.setPaging(this.overdueCurrPage, this.overduePageSize);
    this.overdueParams.filters.overdue = true;
    this.overdueParams.filters.customerCode = this.customerCode;
    this.overdueParams.setOrdering('DueDate', 'asc');
    const overdueInv: any = await this.invoiceService.getInvoices(this.overdueParams);
    this.overdueTotalElements = overdueInv.totalRecords;
    this.overdueTotalPages = overdueInv.totalPages;
    this.overdueInvoices = overdueInv.results;
    return overdueInv;
  }

  async getInvoicesInRange(): Promise<any> {
    this.invoiceParams.setPaging(this.invoiceCurrPage, this.invoicePageSize);
    this.invoiceParams.filters.customerCode = this.customerCode;
    this.invoiceParams.filters.state = "4,6";
    this.invoiceParams.setOrdering('DateOfInvoice', 'desc');
    this.invoiceParams.filters.dateRange = this.startDate.toString() + ',' +  this.endDate.toString();
    const invoiceResults: any = await this.invoiceService.getInvoices(this.invoiceParams);
    this.invoiceTotalElements = invoiceResults.totalRecords;
    this.invoiceTotalPages = invoiceResults.totalPages;
    this.invoices = invoiceResults.results;
    return invoiceResults;
  }
  async setOverduePage(event: { pageNumber: number, pageSize:number ;sortField?: string, sortDirection?: string }): Promise<void> {
        this.loaded = false;
        this.overduePageSize=event.pageSize;
       this.overdueCurrPage = event.pageNumber;
        if(event.sortField==""){
         this.invoiceParams.setOrdering('DateOfInvoice', 'desc');
        }else{
        this.overdueParams.setOrdering(event.sortField, event.sortDirection);
        }
        await this.getOverdueInvoices();
        this.loaded = true;
        }
async setInvoicesPage(event: { pageNumber: number, pageSize:number ;sortField?: string, sortDirection?: string }): Promise<void> {
        this.loaded = false;
        this.invoicePageSize=event.pageSize;
       this.invoiceCurrPage = event.pageNumber;
        if(event.sortField==""){
            this.invoiceParams.setOrdering('DueDate', 'asc');
        }else{
        this.invoiceParams.setOrdering(event.sortField, event.sortDirection);
        }
        await this.getInvoicesInRange();
        this.loaded = true;
        }
  onEnterKey(event: KeyboardEvent) {
      event.preventDefault();
      event.stopPropagation();
      this.getInvoices();
    }

}